import React from 'react';
import { LanguagePairLink } from 'src/types/link';
import gbAndUsaFlagSrc from './images/gb-and-usa-flag.png';
import portugalAndBrazilFlagSrc from './images/portugal-and-brazil-flag.png';
import spainAndMexicoFlagSrc from './images/spain-and-mexico-flag.png';
import * as S from './styles';

const imageByName: { [name in string]?: string } = {
  'multi-country-flag-en': gbAndUsaFlagSrc,
  'multi-country-flag-es': spainAndMexicoFlagSrc,
  'multi-country-flag-pt': portugalAndBrazilFlagSrc,
};

export const LinkImage = ({ externalSrc, name }: LanguagePairLink['image']) => {
  const imageSrc = name ? (imageByName[name] ?? externalSrc) : externalSrc;

  if (imageSrc) {
    return (
      <S.FlagImageWrapper>
        <S.FlagImage src={imageSrc} alt="" data-testid="FlagImage" />
      </S.FlagImageWrapper>
    );
  }

  return null;
};
